import { useContext, useEffect, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { RiWhatsappLine } from "react-icons/ri";
// import { withTranslation } from "react-i18next";

import "./index-header.css";
import EPLogo from "../elements/ep-logo";
import { whatsAppRedirect } from "../../hooks/common";
// import Darkmode from "../darkMode";

export function Header(props) {
  const [scrollY, setScrollY] = useState(0);
  const [borderStyle, setBorderStyle] = useState("none");

  // const [value, setValue] = useState(props.language || props.i18n.language);
  // useEffect(() => {
  //   console.log("--->" + props.language);
  // }, [props.language]);

  const onLanguageHandle = (lang) => {
    // console.log(lang);
    // setValue(lang);
    // props.i18n.changeLanguage(lang);
  };
  // const { t } = props;

  function handleScroll() {
    setScrollY(window.scrollY);
  }

  useEffect(() => {
    function watchScroll() {
      window.addEventListener("scroll", handleScroll);
    }
    watchScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  useEffect(() => {
    if (scrollY > 30) {
      setBorderStyle("1px solid var(--tcColor1)");
    } else {
      setBorderStyle("none");
    }
  }, [scrollY, setBorderStyle]);

  return (
    <>
      <Navbar
        expand="lg"
        sticky="top"
        className="headerMain"
        style={{ padding: "1.5rem 0", borderBottom: borderStyle }}
      >
        <Container className="navbar-container">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Brand className="logo" href="/">
            <EPLogo />
          </Navbar.Brand>
          <Navbar.Collapse className="collapseArea" id="basic-navbar-nav">
            <Nav className="navCenter">
              <Nav.Link href="/">Início</Nav.Link>
              <Nav.Link href="/#sobre-a-professora">Sobre</Nav.Link>
              <Nav>
                <NavDropdown title="Serviços" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/redacao-enem">
                    Redação ENEM 
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/correcoes-para-concursos">
                    Correções para Concursos
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/producao-textual-para-vestibulares">
                    Vestibulares
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/mentorias-individuais">
                    Mentoria Individual
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
              <Nav.Link href="/#como-funciona">Como Funciona</Nav.Link>
              <Nav.Link href="/#depoimentos">Depoimentos</Nav.Link>
              <Nav.Link href="/#faq">FAQ</Nav.Link>
              <Nav.Link
                className="btn-whatsapp-line"
                onClick={whatsAppRedirect}
                target="_blank"
                rel="noreferrer"
              >
                <RiWhatsappLine />
                <p className="text-quero-melhorar">
                  Quero Melhorar Minha Redação
                </p>
              </Nav.Link>
            </Nav>
            {/* <Nav>
              <NavDropdown
                title={t("languages")}
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item onClick={() => onLanguageHandle("pt-BR")}>
                  {t("navbar_header.dropdown_menu.languagePt")}
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => onLanguageHandle("en-US")}>
                  {t("navbar_header.dropdown_menu.languageEn")}
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav className="navTopHiddenLinks">
              <NavDropdown.Divider />
              <Nav.Link to={activeUrl}>
                {t("headerTop.active")} <BsPhone />
              </Nav.Link>
            </Nav> */}
          </Navbar.Collapse>
          {/* <Link to="cart" className="linkIcon">
            <BsCart3 size="1.5rem" />
          </Link> */}
        </Container>
      </Navbar>
    </>
  );
}

// export default withTranslation()(Header);
export default Header;
